import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { MasterRoutes, AuthRoutes } from '../../utilities/routes';
import { Messages } from '../../utilities/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UsersType } from '../../utilities/common-file';
import { EncryptStorage } from 'encrypt-storage';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RolesService } from 'src/app/roles/roles.service';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { SystemSearch } from 'src/app/models/System';
import { Config } from 'src/environments/config';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loginButtonLoading = false;
  passwordVisible = false;
  settingRole: boolean ;
  config = Config;

  private tableData: NzTableData<SystemSearch, any> = new NzTableData <SystemSearch, any>(new SystemSearch(), 'name');
  constructor(private fb: UntypedFormBuilder, private authService: AuthService, private router: Router, private message: NzNotificationService,private deviceService: DeviceDetectorService, private roleService: RolesService ) 
  {
    if(this.authService.getAuthToken()){
      this.router.navigate([MasterRoutes.dashboard]);
     }else{
      this.router.navigate([AuthRoutes.login]);
     }
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ['', [ Validators.required]],
      password: [null, [Validators.required]],
      rememberMe: [false],
      deviceSignature:['', [Validators.required]]
    });

  // To retain Email, Password and remember me checkmark in form after logout if remember me is checked true

    const remememberMe =  this.authService.getRememberMe();
    if (remememberMe) {
      this.loginForm.controls.rememberMe.setValue(this.authService.getRememberMe());
      this.loginForm.controls.email.setValue(this.authService.getEmail());
      var deviceSignature = this.deviceService.getDeviceInfo();  
      var deviceDetails =  deviceSignature.os+' '+ deviceSignature.os_version + ',' +deviceSignature.browser+' '+deviceSignature.browser_version;   
      this.loginForm.controls.deviceSignature.setValue('Web'+ '(' +deviceDetails + ')');
      // tslint:disable-next-line: max-line-length

      if (this.authService.getPassword() && (typeof this.authService.getPassword() !== 'string')) {
        const decryptedPassword = this.authService.getPassword().toString();
        this.loginForm.controls.password.setValue(decryptedPassword);
      } else {
        const decryptedPassword = this.authService.getPassword();
        this.loginForm.controls.password.setValue(decryptedPassword);
      }
      this.authService.setDeviceSignature('Web'+ '(' + deviceDetails + ')')
    } else {
      var deviceSignature = this.deviceService.getDeviceInfo();  
      var deviceDetails =  deviceSignature.os+' '+ deviceSignature.os_version + ',' +deviceSignature.browser+' '+deviceSignature.browser_version;   
      this.loginForm.controls.deviceSignature.setValue('Web'+ '(' +deviceDetails + ')');
      this.authService.setDeviceSignature('Web'+ '(' + deviceDetails + ')')
    }
  }

  submitForm(): void {
    this.loginButtonLoading = true;
    if (this.loginForm.valid) {
      this.message.info('Please Wait', 'Loading', {
        nzKey: 'key'
      });
      this.authService.login(this.loginForm.value).subscribe((response: any) => {
         if (response && response.data && !response.data.isOTPSent) {
          this.authService.refreshTokens().subscribe((resForRefreshToken) => {
            if (response.data.role === UsersType.merchantUser || response.data.role === UsersType.locationUser ||
               response.data.role === UsersType.locationManager) {
              this.message.success(Messages.loginSuccess, '', {
                nzKey: 'key'
              });
              this.setAccessModules();   
              this.settingRole = true;
             encryptStorage.setItem('merchantId',response.data.merchant.id); 
            encryptStorage.setItem('merchantName',response.data.merchant.name); 
            encryptStorage.setItem('currencySymbol',response.data.merchant.currencySymbol);  
              this.router.navigate([MasterRoutes.dashboard]);
              this.loginButtonLoading = false;
            } else {
              this.loginButtonLoading = false;
              this.router.navigate([AuthRoutes.authError]);
            }
            }, err => {
              this.loginButtonLoading = false;
            });
        }

    }, (error: any) => {
      console.log(error);
      this.message.error(error.error.message, '', {
        nzKey: 'key'
      });
      this.loginButtonLoading = false;
    });
    } else {
      this.loginButtonLoading = false;
       // tslint:disable-next-line: forin
      for (const i in this.loginForm.controls) {
      this.loginForm.controls[i].markAsDirty();
      this.loginForm.controls[i].updateValueAndValidity();
    }
      this.message.error(Messages.error, '', {
        nzKey: 'key'
      });
    }
  }
  gotToForgotPassword() {
    this.router.navigate([AuthRoutes.forgotPassword]);
  }
  arrayOfImgUrls = [
    'assets/slider/slider-1@2x.jpg',
    'assets/slider/slider-2@2x.jpg',
    'assets/slider/slider-3@2x.jpg',
    'assets/slider/slider-4@2x.jpg',
    
  ]

  setAccessModules() {
    this.settingRole = true;
    this.roleService.getRoleDetailsById().subscribe((response: any) => {      
      if (response.data.backofficeUserRoleDetails) {
      if (response.data.backofficeUserRoleDetails.length > 0) {
        this.tableData.search.name = 'gst';
        this.tableData.pageIndex = 1;
        this.tableData.pageSize = 1;
        this.tableData.search.appCode = '*';
        this.authService.getSystemWithLimit(this.tableData).subscribe((response: any) => {
          // console.log('response',response);
          if (response.data && response.data.settings.length > 0) {
            if(response.data.settings[0].data.gst){
              console.log('GST',response.data.settings[0].data.gst)
              localStorage.setItem('gst','true');
              localStorage.setItem('hst',this.config.hst);
            }
          } 
          else {
          localStorage.setItem('gst','false');
          localStorage.setItem('hst',this.config.hst);

          }
        }, (err) => {
        });
        this.tableData.search.name = 'monthly_transfer_fee';
        this.tableData.pageIndex = 1;
        this.tableData.pageSize = 1;
        this.tableData.search.appCode = '*';
        this.authService.getSystemWithLimit(this.tableData).subscribe((response: any) => {
          if (response.data && response.data.settings.length > 0) {
               localStorage.setItem('monthly_transfer_fee',response.data.settings[0].data.isMonthlyTransferFee);
           } 
        }, (err) => {
        });
        this.authService.setRoleAccessModule((JSON.stringify(response.data.backofficeUserRoleDetails).toString()));
        this.router.navigate([MasterRoutes.dashboard]);
      } else {
        this.authService.setRoleAccessModule((JSON.stringify([])).toString());
        this.router.navigate([MasterRoutes.dashboard]);
      }
    } else {
      this.authService.setRoleAccessModule((JSON.stringify([])).toString());
      this.router.navigate([MasterRoutes.dashboard]);
    }
    }, error => {
      this.router.navigate([MasterRoutes.dashboard]);
      if (error.error.message == Messages.noData) {
        this.authService.setRoleAccessModule((JSON.stringify([])).toString());
        this.router.navigate([MasterRoutes.dashboard]);
      }
    });

  }
}
